/*
 * Copyright (c) 2019 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './carousel-dropdown.stache';
import BaseList from 'scripts/models/base/list';

Component.extend({
    tag: 'carousel-dropdown',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            items: {
                Type: BaseList,
            },
            selectedValue: {
                type: 'string',
            },
            itemValueProperty: {
                type: 'string',
            },
            itemShowProperty: {
                type: 'string',
            },
            expanded: {
                type: 'boolean',
                value: false,
            },
            selectedItemShow: {
                get() {
                    return this.attr('items').getItemByField(
                        this.attr('selectedValue'),
                        this.attr('itemValueProperty'),
                    )[this.attr('itemShowProperty')];
                },
            },
            itemsShow: {
                get() {
                    return this.attr('items').map((item) => {
                        return item[this.attr('itemShowProperty')];
                    });
                },
            },
            currentIndex: {
                get() {
                    return this.attr('items').getItemIndexByField(
                        this.attr('selectedValue'),
                        this.attr('itemValueProperty'),
                    );
                },
            },
            leftArrowIsDisabled: {
                get() {
                    return this.attr('currentIndex') === 0;
                },
            },
            rightArrowIsDisabled: {
                get() {
                    return (
                        this.attr('currentIndex') ===
                        this.attr('items').length - 1
                    );
                },
            },
        },
        toggleExpanded: function() {
            this.attr('expanded', !this.attr('expanded'));
        },
        updatedIndex: function(index) {
            const newSelectedValue = this.attr('items')[index][
                this.attr('itemValueProperty')
            ];
            this.attr('selectedValue', newSelectedValue);
            this.attr('expanded', false);
            this.dispatch({
                type: 'onChange',
                payload: { value: newSelectedValue },
            });
        },
    },
    events: {
        '.js-dropdown-item click': function($element) {
            this.viewModel.updatedIndex($element.attr('data-value'));
        },
        '.js-dropdown-arrow-left click': function() {
            this.viewModel.updatedIndex(
                this.viewModel.attr('currentIndex') - 1,
            );
        },
        '.js-dropdown-arrow-right click': function() {
            this.viewModel.updatedIndex(
                this.viewModel.attr('currentIndex') + 1,
            );
        },
    },
});
